<div class="navbar-tools"
     data-cy="navigation-tools"
     id="toolbar"
>
  <mb-link [linkData]="{uid: cmsLinkType.SPECIAL}"
           [useSlot]="true"
           [styleClass]="['d-inline', 'tools-default']"
           (clickEvent)="searchClick.emit(); sendGTMEvent.emit($event)"
           dataCy="navigation-search-icon"
           dataEventAction="Click Tools-Search"
           dataEventCategory="IconNavi"
           data-tools-target="search"
  >
    <img [class.mb-search-icon]="showSearch"
         alt="search"
         src="/assets/images/Icon_search.svg"
         title="search"
    >
  </mb-link>
  <mb-link [linkData]="{uid: cmsLinkType.SPECIAL}"
           [routerLink]="{ cxRoute: 'cart' } | cxUrl"
           [useSlot]="true"
           (clickEvent)="sendGTMEvent.emit($event)"
           styleClass="d-inline"
           data-current-node="/sites/site@live;country=DE,DACH,INTERNATIONAL&amp;language=en"
           dataCy="navigation-cart-icon"
           dataEventAction="Click Tools-Cart"
           dataEventCategory="IconNavi"
           data-link="https://www.miltenyibiotec.com/DE-en/shop/checkout/cart"
  >
    <img alt="cart"
         data-icon="cart"
         src="/assets/icons/svg/Icon_cart.svg"
         title="cart"
    >
  </mb-link>
  <mb-link *ngIf="supportsAccountCreation$ | async"
           [linkData]="{uid: cmsLinkType.SPECIAL}"
           [routerLink]="{ cxRoute: 'myAccount' } | cxUrl"
           [styleClass]="['d-none', 'd-md-inline']"
           [useSlot]="true"
           (clickEvent)="sendGTMEvent.emit($event)"
           dataCy="navigation-my-account-icon"
           dataEventAction="Click Tools-Account"
           dataEventCategory="IconNavi"
           data-link="/myaccount"
  >
    <img [src]="(userIsLoggedIn$ | async) ? '/assets/images/Icon_user-loc.svg' : '/assets/images/Icon_user.svg'"
         alt="my account"
         data-icon="user"
         title="my account"
    >
  </mb-link>
  <mb-link *ngIf="!(supportsGuestCheckout$ | async)"
           [linkData]="{uid:'special'}"
           [routerLink]="{ cxRoute: 'myWishlist' } | cxUrl"
           [styleClass]="['d-none', 'd-lg-inline']"
           [useSlot]="true"
           (clickEvent)="sendGTMEvent.emit($event)"
           data-current-node=""
           dataCy="navigation-favorites-icon"
           dataEventAction="Click Tools-Fav"
           dataEventCategory="IconNavi"
           data-link="/myaccount/wishlist"
  >
    <img alt="favorite list"
         data-icon="favorites"
         src="/assets/images/icons-2/Icon_header_heart.svg"
         title="favorite list"
    >
  </mb-link>
  <mb-link [linkData]="{uid: cmsLinkType.SPECIAL}"
           [styleClass]="['d-none', 'd-lg-inline']"
           [useSlot]="true"
           (clickEvent)="contactClick.emit($event); sendGTMEvent.emit($event)"
           dataCy="navigation-contact-icon"
           dataEventAction="Click Tools-Contact"
           dataEventCategory="IconNavi"
           data-tools-target="contact"
  >
    <img alt="contact"
         src="/assets/images/contact_mixed.svg"
         title="contact"
    >
  </mb-link>
</div>
<div class="d-block d-lg-none"
     id="burger"
>
  <mb-link [linkData]="{uid: cmsLinkType.SPECIAL}"
           [useSlot]="true"
           dataCy="mobile-navigation-menu"
           id="mobile-menu-open"
  >
    <img (click)="mobileMenuClick.emit()"
         alt="Menu"
         data-cy="mobile-navigation-menu-image"
         src="/assets/images/Icon_burger.svg"
         title="Menu"
    >
  </mb-link>
</div>